import { Component, ViewChild } from '@angular/core';
import {
  breadcrumb,
  link,
  stat,
} from 'src/app/admin/layout/header/header.component';
import { QuestionBase } from 'src/app/misc/component/dynamic-form/question-base';
import { DropdownQuestion } from 'src/app/misc/component/dynamic-form/question-dropdown';
import { TextboxQuestion } from 'src/app/misc/component/dynamic-form/question-textbox';
import icons from '../../../../misc/data/icons.json';
import { SelectItem } from 'primeng/api';
import { DataService } from 'src/app/services/data.service';
import { DynamicFormComponent } from 'src/app/misc/component/dynamic-form/dynamic-form.component';
import { Message } from 'primeng/api';
import {
  ConfirmationService,
  MessageService,
  ConfirmEventType,
} from 'primeng/api';
import { PermissionHandlerService } from 'src/app/services/permission-handler.service';

import { TranslatorPipe } from 'src/app/services/translator.pipe';
import { IconBoxQuestion } from 'src/app/misc/component/dynamic-form/question-iconbox';

@Component({
  selector: 'app-types',
  templateUrl: './types.component.html',
  styleUrls: ['./types.component.scss'],
  providers: [ConfirmationService, MessageService],
})
export class TypesComponent {
  skelition = true;

  @ViewChild(DynamicFormComponent) DynamicFormComponent:
    | DynamicFormComponent
    | any;

  messages: Message[] = [];
  translator: TranslatorPipe = new TranslatorPipe()

  header = 'أنواع الوحدات التنظيمية'
  links: link[] = [
    {
      name: 'رجوع',
      icon: 'pi pi-angle-right',
      link: '/admin/organization-units',
      visible: this.permissionService.hasPermission('OU', 'r')
    },
    {
      name: 'التصنيفات',
      icon: 'pi pi-sitemap',
      link: '/admin/organization-units/categories',
      visible: this.permissionService.hasPermission('OU_CATEGORY', 'r')
    },
    {
      name: 'المدن',
      icon: 'pi pi-map-marker',
      link: '/admin/organization-units/locations',
      visible: this.permissionService.hasPermission('OU_LOCATION', 'r')
    },
  ];
  breadcrumbs: breadcrumb[] = [
    { name: this.translate('Entities'), link: '/admin/organization-units' },
    {
      name: this.translate('Types of organizational units'),
      link: '/admin/organization-units/types',
    },
  ];
  stats: stat[] = [];

  catdata: any[] = [];

  data: any[] = [];
  iconOptions: SelectItem[] = [];
  questions: QuestionBase<string>[] = [];
  tags: any[] = [
    { label: this.translate("Ministries/Entities"), value: "Ministries/Entities" },
    { label: this.translate("Organisational Units"), value: "Organisational Units" },
    { label: this.translate("Organisational Structure"), value: "Organisational Structure" },
    { label: this.translate("Branches"), value: "Branches" },
    { label: this.translate("Content Related"), value: "Content Related" }
  ]
  // Update data
  updateModal = false;
  updateData: any;
  updateQuestions: any;

  constructor(
    private dataService: DataService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    public permissionService: PermissionHandlerService
  ) { }

  ngOnInit() {
    icons.forEach((icon: { i: string; n: string }) => {
      this.iconOptions.push({ label: icon.n, icon: icon.i, value: icon.i });
    });

    this.iconOptions = this.iconOptions.sort((a, b) => {
      if (a.label && b.label) {
        if (a.label < b.label) {
          return -1;
        }
        if (a.label > b.label) {
          return 1;
        }
        return 0;
      } else {
        return 0;
      }
    });

    this.getOuType();
    let allowedTags = this.permissionService.extractTags('OU_TYPE', 'c');
    this.tags = this.tags.filter((t) => allowedTags.includes(t.value));
    this.makequestion();
  }
  translate(key: string) {
    let translator: TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }
  getOuType = async () => {
    try {
      let allowedTags = this.permissionService.extractTags('OU_TYPE', 'r');
      let res = await this.dataService.getData('ou-type');
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.catdata = res.data.filter((t: any) => allowedTags.includes(t.tag));
      this.catdata.forEach((item: any) => {
        this.data.push({
          '#': { n: item._id, i: 'pi pi-angle-left' },
          'اسم النوع': { n: item.name, i: item.icon },
          'علامة': { n: item.tag },
          'الحالة': {
            n: item.active,
            i: item.active ? 'pi pi-check-circle' : 'pi pi-check-circle',
          },
          Action: [
            {
              n: 'Delete',
              i: 'pi pi-times',
              s: 'p-button-rounded p-button-danger p-button-text p-button-raised',
            },
            {
              n: 'Update',
              i: 'pi pi-file-edit',
              s: 'p-button-rounded p-button-warning p-button-text p-button-raised',
            },
          ],
        });
      });
      this.updateTypeCounts();
      this.skelition = false;
      console.log('data ou catagory => ', this.catdata, this.data);
    } catch (error) {
      console.log(error);
    }
  };

  makequestion() {
    this.questions = [
      new TextboxQuestion({
        key: 'name',
        label: 'اسم النوع',
        required: true,
        order: 1,
        icon: 'pi pi-file',
        className: 'col-md-12 col-sm-12 col-12',
      }),

      new IconBoxQuestion({
        key: 'icon',
        label: 'الايقونات',
        required: true,
        
        filter: true,
        order: 3,
        className: 'col-md-12 col-sm-12 col-12',
      }),

      new DropdownQuestion({
        key: 'tag',
        label: 'علامة',
        required: true,
        options: this.tags,
        filter: true,
        order: 4,
        className: 'col-md-12 col-sm-12 col-12',
      }),

      new DropdownQuestion({
        key: 'active',
        label: 'الحالة',
        options: [
          { label: this.translate('active'), icon: 'pi pi-check-circle', value: true },
          { label: this.translate('Inactive'), icon: 'pi pi-times-circle', value: false },
        ],
        order: 5,
        className: 'col-md-12 col-sm-12 col-12',
        value: true,
        visibility: "false"
      }),
    ];
  }

  receiveData = async ($event: any) => {
    try {
      let data = $event;
      let res = await this.dataService.postData('ou-type', data);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.messages = [
        { severity: 'success', summary: this.translate('success'), detail: res.msg },
      ];
      this.DynamicFormComponent.resetForm();

      this.catdata.push(res.data);
      console.log('TEST DATA+=======>', this.catdata);
      this.data.unshift({
        '#': { n: res.data._id, i: 'pi pi-angle-left' },
        'اسم النوع': { n: data.name, i: data.icon },
        'علامة': { n: data.tag },
        'الحالة': {
          n: data.active,
          i: data.active ? 'pi pi-check-circle' : 'pi pi-check-circle',
        },
        Action: [
          {
            n: 'Delete',
            i: 'pi pi-times',
            s: 'p-button-rounded p-button-danger p-button-text p-button-raised',
          },
          {
            n: 'Update',
            i: 'pi pi-file-edit',
            s: 'p-button-rounded p-button-warning p-button-text p-button-raised',
          },
        ],
      });
      this.updateTypeCounts();
    } catch (error) {
      console.log(error);
    }
  };

  UpdateData = async ($event: any) => {
    try {
      let data: any = $event;
      data._id = this.updateData._id;
      let res = await this.dataService.postData('ou-type', data, 'PUT', false);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.messages = [
        { severity: 'success', summary: this.translate('success'), detail: res.msg },
      ];
      this.updateModal = false;
      this.updateData = undefined;
      // updating in table
      const myObject = this.data.find((item) => item['#'].n === data._id);
      if (myObject) {
        (myObject['اسم النوع'].n = data.name), (myObject['اسم النوع'].i = data.icon);
        myObject['علامة'].n = data.tag;
        myObject['الحالة'].n = data.active;
        myObject['الحالة'].i = data.active
          ? 'pi pi-check-circle'
          : 'pi pi-check-circle';
      }

      this.data.map((e, i) => {
        if (e['#'].n === data._id) {
          this.data[i] = myObject;
          return;
        }
      });

      this.catdata.map((e, i) => {
        if (e._id === data._id) {
          this.catdata[i] = data;
          return;
        }
      });
      console.log(this.catdata);
      this.updateTypeCounts();
    } catch (error) {
      console.log(error);
    }
  };

  actionCall($event: any) {
    console.log('==> Action Call recieved=', $event);
    switch ($event.action) {
      case 'Delete':
        this.confirm({
          message: this.translate('Are you sure you want to do this?'),
          header: this.translate('Confirmation message'),
          icon: 'pi pi-exclamation-triangle',
          action: () => this.deleteCatagory($event.id),
        });
        break;
      case 'Update':
        this.updateData = this.catdata.find((item) => item._id == $event.id);
        this.updateQuestions = [
          new TextboxQuestion({
            key: 'name',
            label: 'اسم النوع',
            required: true,
            order: 1,
            icon: 'pi pi-file',
            value: this.updateData.name,
            className: 'col-12',
          }),

          new IconBoxQuestion({
            key: 'icon',
            label: 'الايقونات',
            required: true,
            
            filter: true,
            order: 3,
            value: this.updateData?.icon,
            className: 'col-12',
          }),

          new DropdownQuestion({
            key: 'tag',
            label: 'العلامات',
            required: true,
            options: this.tags,
            filter: true,
            order: 4,
            className: 'col-md-12 col-sm-12 col-12',
            value: this.updateData?.tag
          }),

          new DropdownQuestion({
            key: 'active',
            label: 'الحالة',
            required: true,
            value: this.updateData?.active,
            options: [
              { label: this.translate('active'), icon: 'pi pi-check-circle', value: true },
              { label: this.translate('Inactive'), icon: 'pi pi-times-circle', value: false },
            ],
            order: 4,
            className: 'col-12',
          }),
        ];
        console.log('Update Data ==>', this.catdata, this.updateData);
        this.updateModal = true;
        break;
      default:
        console.log('Unknown color');
        break;
    }
  }

  deleteCatagory = async (id: string) => {
    try {
      let res = await this.dataService.deleteData(`ou-type/${id}`);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.messages = [
        { severity: 'success', summary: this.translate('success'), detail: res.msg },
      ];
      this.data = this.data.filter((item) => item['#'].n !== id);
      this.catdata = this.catdata.filter((item) => item._id !== id);
      this.updateTypeCounts();
    } catch (error) {
      console.log(error);
    }
  };

  confirm(parems: any) {
    this.confirmationService.confirm({
      message: parems.message,
      header: parems.header,
      icon: parems.icon,
      acceptLabel: 'نعم',
      rejectLabel: 'لا',
      accept: () => {
        parems.action();
        return true;
      },
      reject: (type: any) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            return false;
          case ConfirmEventType.CANCEL:
            return false;
          default:
            return false;
        }
      },
    });
  }

  private updateTypeCounts(): void {
    let activeCount = this.catdata.filter((e) => e.active === true).length;
    let inactiveCount = this.catdata.length - activeCount;
    this.stats = [
      { name: this.translate('active'), number: activeCount, icon: 'pi pi-check-circle' },
      { name: this.translate('Inactive'), number: inactiveCount, icon: 'pi pi-times-circle' },
    ];
  }
}
